<template>
  <div>
    <div
      style="background-color: #E9EAEC; width: 700px; text-align: center; center; padding: 25px 25px"
    >
      <div style="text-align: right;">
        <!-- <button
          type="button"
          class="btn btn-lg"
          style="background-color: #E9EAEC !important; border: none !important; padding: 0px;"
          @click="handleChangeLang()"
        >
          
        </button> -->
        <img
          @click="handleChangeLang()"
          class="img-fluid mr-1"
          :src="flagSrcSwitch"
          width="30"
          style="cursor: pointer"
        />
      </div>
      <div style="width: 100%;" v-if="isCanAccess">
        <img src="../assets/img/logo.png" style="width: 80px" /><br /><br />
        <img
          v-if="loading"
          src="../assets/img/preloader.gif"
          style="width: 80px"
        /><br /><br />
        <span
          style="font-size: 22px; font-weight: bold;"
          v-html="$t('messages.general.queNewText1')"
        ></span>
        <br /><br />
        <span style="font-size: 18px;"
          >{{ $t("messages.general.queNewText5") }}
          <a :href="oldUrl" target="_blank">{{
            $t("messages.general.queNewText6")
          }}</a></span
        >
        <!-- <span style="font-size: 36px; font-weight: bold;"
          >{{ $t("messages.general.que") }} : {{ que }}</span
        ><br /><br />
        <span
          style="font-size: 24px;"
          v-html="$t('messages.general.queTxt1')"
        ></span
        ><br /><br /> -->
        <!-- <span
          style="margin-top: 10px; font-weight: bold; color: red; font-size: 24px"
          v-html="$t('messages.general.queTxt2')"
        ></span> -->
        <!-- <br /><br />
        <span style="font-size: 20px; font-weight: bold;"
          >{{ $t("messages.general.currentQue") }} : {{ currentQue }}</span
        > -->
        <!-- <br /><br />
        <span
          >{{ $t("messages.general.queTxt3") }} {{ currentTime }}
          {{ suffixTime }}</span
        >  -->
      </div>
      <div style="width: 100%;" v-if="!isCanAccess">
        <img src="../assets/img/logo.png" style="width: 80px" /><br /><br />
        <span
          style="font-size: 22px; font-weight: bold;"
          v-html="this.currentLang === 'th' ? loginResponseMessageTH : loginResponseMessageEN"
        ></span
        ><br /><br />
        <span style="font-size: 18px;"
          ><a :href="backToRegUrl">{{ $t("messages.general.99") }}</a></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/th";
import MasterDataProvider from "@/services/masterData_provider";
import GatewayProvider from "@/services/gateway_provider";
// import UserProvider from "@/services/user_provider";

const masterDataProvider = new MasterDataProvider();
const gatewayProvider = new GatewayProvider();
// const userProvider = new UserProvider();

import thaiFlagSrc from "../assets/img/svg/th.svg";
import enFlagSrc from "../assets/img/svg/gb.svg";

export default {
  name: "DataTransfer",
  data: () => {
    return {
      loginResponseMessageTH: "",
      loginResponseMessageEN: "",
      sessionGuid: "",
      seq: "",
      error: "",
      token: "",
      userid: 0,
      misuserid: 0,
      message: "",
      que: "-",
      currentQue: "-",
      currentTime: "-",
      loading: false,
      isCanAccess: true
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      isRedirectStatement: "isRedirectStatement",
      userinfo: "getUserInfo"
    }),
    getNextDate: function() {
      let dt = new Date();
      dt.setMinutes(dt.getMinutes() + 15);
      return dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    },
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    suffixTime: function() {
      return this.currentLang == "th"
        ? this.$t("messages.general.suffixQueTime")
        : "";
    },
    setSwitchLang: function() {
      return this.currentLang == "th" ? "EN" : "TH";
    },
    flagSrcSwitch: function() {
      return this.currentLang == "th" ? enFlagSrc : thaiFlagSrc;
    },
    oldUrl: function() {
      return `https://${process.env.VUE_APP_ER_OLD}/course-infomation`;
    },
    backToRegUrl: function() {
      return `https://${process.env.VUE_APP_ER_OLD}/backend/`;
    }
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "initApplication",
      "setQueToken",
      "setMenu",
      "setCurrentUserAsync",
      "setSessionGuid",
      "setSeq",
      "clearToken",
      "setCurrentUser",
      "switchTheme",
      "setRedirectPage",
      "setDatatransfer",
      "setCurrentLocale",
      "clearStudentInfo"
    ]),
    toPromise: function(promise) {
      return promise
        .then(data => {
          return data;
        })
        .catch(err => {
          return err;
        });
    },
    wait: function(delay) {
      var start = new Date().getTime();
      while (new Date().getTime() < start + delay);
    },
    handleChangeLang() {
      this.setCurrentLocale();
    },
    async checkQueue(isCheck, tokenQueue, sessionId, seq) {
      let is_check = isCheck;
      let token = tokenQueue;
      const self = this;
      const route = this.$route;
      const router = this.$router;
      if (!is_check) {
        this.loading = true;
        // const resAlive = await userProvider.keepalive(token);
        // if (resAlive.status == 200) {
        //   token = resAlive.data.token;
        // }
        const res = await gatewayProvider.check({
          token: token
        });
        this.que = res.queue;
        this.currentQue = res.current_queue;
        is_check = res.is_check;
      }
      if (!is_check) {
        // self.currentTime = moment().format(`HH:mm:ss`);
        // setTimeout(function() {
        //   self.checkQueue(false, token, sessionId, seq);
        // }, 10000);
      } else {
        this.loading = false;
        self.setSessionGuid(sessionId);
        self.setSeq(seq);
        self.token = token;

        await self.toPromise(
          self.setCurrentUserAsync({
            token: token,
            request: {
              userid: self.userid,
              lang: self.currentLang
            }
          })
        );

        const menus = await self.toPromise(
          masterDataProvider.getMenu({
            token: token,
            userId:
              self.userinfo.data.USER_TYPE === "S"
                ? self.userid
                : self.misuserid,
            lang: self.currentLang
          })
        );

        if (self.userinfo) {
          setTimeout(function() {
            self.setDatatransfer({
              token: tokenQueue,
              menus: menus && menus.length > 0 ? menus : false,
              userid: self.userid,
              misuserid: self.misuserid,
              showPreLoader: false
            });
            let redirect =
              route.query.redirect !== undefined
                ? route.query.redirect
                : menus.length > 0 && menus[0].ENROLLPERIOD == 1
                ? "/register"
                : "/";
            router.push(redirect);
          }, 2000);
        }
      }
    },
    async fetchRetry(retries = 3) {
      const strMessage = "pingTest was timeout in " + retries + " times";
      if (retries > 0) {
        const resultPingTest = await gatewayProvider.pingTest();
        console.log(strMessage, resultPingTest);
        if (
          Object.prototype.hasOwnProperty.call(resultPingTest, "data") &&
          resultPingTest.data === "alive"
        ) {
          return true;
        } else {
          await new Promise(resolve => setTimeout(resolve, 3000));
          retries--;
          return await this.fetchRetry(retries);
        }
      } else {
        console.log(strMessage);
        return false;
      }
    },
    async setCookie(id, value) {
      document.cookie = id + "=" + value;
    },
    async getCookie(id) {
      let value = document.cookie.match("(^|;)?" + id + "=([^;]*)(;|$)");
      return value ? unescape(value[2]) : null;
    },
    async deleteCookie(id) {
      document.cookie = id + "=;";
    }
  },
  async mounted() {
    // =========================== Clear LocalStorage ===========================
    localStorage.clear();
    // ==========================================================================
    const self = this;
    const route = this.$route;
    /// const router = this.$router;
    /// self.clearToken();
    const accessToken = await self.getCookie("accessToken");
    // const accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3Mzc2OTMyMjAsIm5iZiI6MTczNzY5MzIyMCwianRpIjoiZDE4OGI1ODUtYjljYS00Yzk0LTlkZWUtNzc5MzhkN2JmNDYxIiwiZXhwIjoxNzM3Njk1MDIwLCJpZGVudGl0eSI6IjY1MzEyMDMxNDUiLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MiLCJ1c2VyX2NsYWltcyI6eyJkYXRhIjp7Ik5BTUUiOiJcdTBlMmFcdTBlMmJcdTBlMGFcdTBlMzFcdTBlMjIiLCJOQU1FRU5HIjoiU0FIQUNIQUkiLCJPRkZJQ0VSSUQiOm51bGwsIlBSRUZJWE5BTUUiOiJcdTBlMTlcdTBlMzJcdTBlMjIiLCJQUkVGSVhOQU1FRU5HIjoiTVIuIiwiU1VSTkFNRSI6Ilx1MGU0MVx1MGUwMVx1MGU0OVx1MGUyN1x1MGU0Mlx1MGUyM1x1MGUyMiIsIlNVUk5BTUVFTkciOiJLQUVXUk9ZIiwiVVNFUkNPREUiOiI2NTMxMjAzMTQ1IiwiVVNFUklEIjo2NTMxMjAzMTQ1LCJVU0VSTkFNRSI6IjY1MzEyMDMxNDUiLCJVU0VSVFlQRSI6MTB9fX0.2cmKPJPLx1oUfMTeB9HsqFdE5Mvd-SZn8I7NOD6LFcE';
    // if (typeof route.query === "undefined") {
    //   self.clearToken();
    //   router.push("/redirecthome");
    //   self.sessionGuid = "No session guid";
    //   self.seq = "No seq";
    //   return;
    // }
    let isHasAccessToken = false;
    if (accessToken === null || accessToken === "") {
      // self.clearToken();
      // router.push("/redirecthome");
      self.sessionGuid = "No session guid";
      self.seq = "No seq";
      return;
    } else {
      isHasAccessToken = true;
    }

    if (
      // typeof route.query.session_guid !== "undefined" ||
      // typeof route.query.sessionguid !== "undefined"
      isHasAccessToken
    ) {
      // const sessionId = typeof route.query.session_guid !== "undefined"
      //   ? route.query.session_guid
      //   : typeof route.query.sessionguid !== "undefined"
      //   ? route.query.sessionguid
      //   : "";
      const sessionId = accessToken;
      const seq =
        typeof this.$route.query.seq !== "undefined"
          ? this.$route.query.seq
          : "";
      const redirectPage =
        typeof route.query.page !== "undefined" ? route.query.page : "";

      self.sessionGuid = sessionId;
      self.setQueToken(false);
      self.clearStudentInfo();
      self.loading = true;
      // =========================== fetchRetry Ping Pong Gateway ===========================
      const resultPingTest = await this.fetchRetry(3);
      // ====================================================================================
      if (!resultPingTest) {
        console.log("Can't ping pong gateway!!!");
        localStorage.clear();
        // router.push("/redirecthome");
      } else {
        console.log("Can ping pong gateway!!!");
        self.setRedirectPage(redirectPage);
        let result = await gatewayProvider.login({
          guid: sessionId
        });
        if (result.code === 401) {
          this.isCanAccess = false;
          if(result.data.length >= 0) {
            this.loginResponseMessageTH = result.data[0].BYTEDES;
            this.loginResponseMessageEN = result.data[0].BYTEDESENG;
          } else {
            this.loginResponseMessageTH = "ยังไม่ถึงช่วงเวลาลงทะเบียนเรียนของคุณ";
            this.loginResponseMessageEN = "Registration is not available at this time.";
          }
          
        } else {
          this.isCanAccess = true;
          let tokenQueue = result.token;
          self.que = result.queue;
          self.currentQue = result.current_queue;
          self.userid = result.userid;
          self.misuserid = result.misuserid;
          let isCheck = result.is_check;
          self.currentTime = moment().format(
            `HH:mm:ss ${self.currentLang == "th" ? "" : "a"}`
          );
          self.checkQueue(isCheck, tokenQueue, sessionId, seq);
        }
      }
    }
  }
};
</script>

<style scoped>
.loader {
  cursor: progress;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: url("../assets/img/preloader.gif") 50% 50% no-repeat
    rgb(249, 249, 249);
  opacity: 0.8;
}
</style>
